import { AsyncPipe, NgClass, NgTemplateOutlet } from "@angular/common";
import {
    AfterContentInit,
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ContentChildren,
    ElementRef,
    inject,
    Input,
    OnChanges,
    QueryList,
    SimpleChanges,
    ViewChild,
    ChangeDetectionStrategy
} from "@angular/core";
import { NgbPopover, Placement } from "@ng-bootstrap/ng-bootstrap";
import { map, Observable, startWith } from "rxjs";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { RaskPopoverDirective } from "../../directives/popover/rask-popover.directive";

@Component({
    selector: "rask-icon",
    styleUrls: ["./icon.component.scss"],
    templateUrl: "./icon.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RaskPopoverDirective,
        NgClass,
        NgTemplateOutlet,
        AsyncPipe
    ]
})
export class IconComponent implements AfterViewInit, OnChanges, AfterContentInit {
    @Input() autoClose: any = true;
    @Input() clickToOpen: boolean;
    @ContentChildren("popoverContent") content: QueryList<ElementRef>;
    hasContent$: Observable<boolean>;
    @Input() helpUrl: string;
    @Input() icon: string;
    @Input() placement: Placement = "auto";
    @Input() popoverClass?: string;
    @Input() popoverContainer?: string;
    popoverDisabled = false;
    @ViewChild("ngbPopover") popoverRef: NgbPopover;
    @Input() popoverTriggers = "mouseenter:mouseleave";
    @ViewChild("templateResult") templateResult;
    @Input() text: string;

    private readonly changeRef = inject(ChangeDetectorRef);

    ngAfterContentInit(): void {
        this.hasContent$ = this.content.changes.pipe(
            map(() => this.content.length > 0),
            startWith(false)
        );
    }

    ngAfterViewInit(): void {
        this.popoverDisabled = this.templateResult.nativeElement.innerText.replace(/ /g, "").length === 0;
        this.changeRef.detectChanges();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.text) {
            this.popoverDisabled = ObjectUtils.isNullOrUndefined(changes.text.currentValue);
        }
        if (this.clickToOpen) {
            this.popoverTriggers = "manual";
        } else {
            if (!this.popoverTriggers) {
                this.popoverTriggers = "mouseenter:mouseleave";
            }
        }
        this.changeRef.detectChanges();
    }

    onOpen(popover) {
        if (this.clickToOpen) {
            popover.open();
        } else if (this.helpUrl) {
            window.open(this.helpUrl, "_blank");
        }
    }
}
